import { Icon } from '../../../Icon';
import { Typography } from '../../../typography';

import s from './DropdownOption.module.css';

export type Option<T extends string = string> = {
  label: string;
  value: T;
};

type DropdownOptionProps<T extends string> = {
  isSelected: boolean;
  onSelect: (value: T) => void;
  option: Option<T>;
};

export const DropdownOption = <T extends string>({ isSelected, onSelect, option }: DropdownOptionProps<T>) => (
  <button className={s.dropdownOption} onClick={() => onSelect(option.value)} type="button">
    <Typography color={isSelected ? 'white' : 'grey-light'} component="span" variant="card-title">
      {option.label}
    </Typography>

    <span className={s.dropdownOption__iconWrapper}>
      {isSelected && <Icon color="color-accent" height={24} name="check" width={24} />}
    </span>
  </button>
);
